import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};
const app = initializeApp(firebaseConfig);

// ── ANALYTICS IS OPTIONAL, AND MUST NOT BE ABLE TO THROW ─────────────────────
// `getAnalytics` fetches a remote config the moment it is called. Anywhere that
// request cannot complete, it rejects and — because nothing awaited it — became
// an unhandled rejection on the page.
//
// That is not hypothetical bookkeeping: the prerender step blocks third-party
// requests (see `reactSnap.skipThirdPartyRequests`, which exists so no page is
// baked with live Firestore data in it), react-snap treats any uncaught page
// error as fatal, and the whole `npm run build` exited non-zero because of it.
// A deploy failed over a metrics call that was never load-bearing.
//
// The same holds in a browser with an ad blocker or tracking protection, which
// blocks this exact request for a large share of real visitors.
//
// So it is best-effort and the export can be null. Nothing in the app reads it
// today; if anything ever does, it must check.
let analyticsInstance = null;
try {
  analyticsInstance = getAnalytics(app);
} catch {
  // Unsupported environment, or the config request was refused. Not a fault.
}
export const analytics = analyticsInstance;
export const auth          = getAuth(app);
export const db            = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
// Region must match setGlobalOptions({ region: ... }) in functions/index.js.
export const functions      = getFunctions(app, 'us-central1');

googleProvider.setCustomParameters({ prompt: 'select_account' });

export default app;
